import React from 'react';

export default function Pagination({ page, totalPages, onPageChange, total, limit }) {
  if (!totalPages || totalPages <= 1) return null;

  const pages = [];
  const start = Math.max(1, page - 2);
  const end = Math.min(totalPages, page + 2);
  for (let i = start; i <= end; i++) pages.push(i);

  return (
    <div className="d-flex align-items-center justify-content-between mt-3 flex-wrap gap-2">
      <div style={{ fontSize: 12, color: '#6c757d' }}>
        Showing {((page - 1) * limit) + 1}–{Math.min(page * limit, total)} of {total} records
      </div>
      <nav>
        <ul className="pagination pagination-sm mb-0">
          <li className={`page-item ${page <= 1 ? 'disabled' : ''}`}>
            <button className="page-link" onClick={() => onPageChange(page - 1)}>
              <i className="bi bi-chevron-left"></i>
            </button>
          </li>
          {start > 1 && <li className="page-item disabled"><span className="page-link">…</span></li>}
          {pages.map(p => (
            <li key={p} className={`page-item ${p === page ? 'active' : ''}`}>
              <button className="page-link" onClick={() => onPageChange(p)}>{p}</button>
            </li>
          ))}
          {end < totalPages && <li className="page-item disabled"><span className="page-link">…</span></li>}
          <li className={`page-item ${page >= totalPages ? 'disabled' : ''}`}>
            <button className="page-link" onClick={() => onPageChange(page + 1)}>
              <i className="bi bi-chevron-right"></i>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
}
